import cls from 'classnames';

import styles from './index.module.scss';
import { LocalImage } from '../../Image';

export type PrimaryBtnProps = {
  text: string;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  icon?: string;
  width?: number | string;
  className?: string;
  disabled?: boolean;
};

export function PrimaryBtn({ text, onClick, icon, width, className, disabled }: PrimaryBtnProps) {
  return (
    <div
      className={cls(styles.primaryBtn, className, disabled && styles.disabled)}
      onClick={onClick}
      style={{ width }}
    >
      {icon && <LocalImage src={icon} />}
      {text}
    </div>
  );
}

export function OutlineBtn({ text, onClick, width, icon, className, disabled }: PrimaryBtnProps) {
  return (
    <div
      className={cls(styles.outlineBtn, className, disabled && styles.disabled)}
      onClick={onClick}
      style={{ width }}
    >
      {icon && <LocalImage src={icon} />}
      {text}
    </div>
  );
}
